<template>
  <nav>
    <v-toolbar flat app class="green darken-3 white--text pr-2">
    <v-toolbar-side-icon class="white--text" @click="drawer = !drawer"></v-toolbar-side-icon>
      <span>{{ bienvenida }}</span>
      <v-spacer></v-spacer>
      <v-btn flat text class="green darken-3 white--text" @click = "cerrarSesion" >
        <v-icon left>mdi-account</v-icon>
        <span>Salir</span>
      </v-btn>
    </v-toolbar>

    <v-navigation-drawer
      id="app-drawer"
      v-model="drawer"
      app
      dark
      floating
      persistent
      mobile-break-point="991"
      width="260">

      <v-layout
        class="fill-height"
        tag="v-list"
        column>

        <v-list-tile avatar>
          <v-list-tile-avatar
            color="white">
            <v-img
              :src = "logo"
              height="40"
              />
          </v-list-tile-avatar>
          <v-list-tile-title class="title">
            JSH<br>Matchmaking Tool
          </v-list-tile-title>
        </v-list-tile>

        <v-divider/>

        <v-list-tile
          v-for="(link, i) in links"
          :key="i"
          :to="link.to"
          :active-class="color"
          avatar
          class="v-list-item">

          <v-list-tile-action>
            <v-icon>{{ link.icon }}</v-icon>
          </v-list-tile-action>

          <v-list-tile-title
            v-text="link.text"/>

        </v-list-tile>
      </v-layout>
    </v-navigation-drawer>
  </nav>
</template>

<script>
import ServiceHandler from '../../ServiceHandler';

// Utilities
import {
  mapMutations,
  mapState
} from 'vuex'

export default {
  data: () => ({
    logo: 'logoJSH.svg',
    drawer: false,
    bienvenida: `Bienvenido(a), ${sessionStorage.getItem("nombre")}`,
    username: '',
    links: [
      {
        to : '/Dashboard',
        icon : 'mdi-home',
        text : 'Dashboard'
      },
      {
        to : '/Centros',
        icon : 'mdi-map-marker-radius',
        text : 'Centros comunitarios'
      },
      {
        to : '/Grupos',
        icon : 'mdi-school',
        text : 'Grupos'
      },
      {
        to : '/Personas',
        icon : 'mdi-account-group-outline',
        text : 'Personas'
      },
      {
        to : '/Servicios',
        icon : 'mdi-compass-outline',
        text : 'Servicios'
      },
      {
        to : '/Empleo',
        icon : 'mdi-briefcase-outline',
        text : 'Empleo'
      },
      {
        to : '/Seguimiento',
        icon : 'mdi-format-list-checks',
        text : 'Seguimiento'
      }
    ],
    responsive: true
  }),
  computed: {
    ...mapState('app', ['image', 'color']),
    inputValue: {
      get () {
        return this.$store.state.app.drawer
      },
      set (val) {
        this.setDrawer(val)
      }
    },
    items () {
      return this.$t('Layout.View.items')
    }
  },
  mounted () {
    this.onResponsiveInverted()
    window.addEventListener('resize', this.onResponsiveInverted)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.onResponsiveInverted)
  },
  methods: {
    ...mapMutations('app', ['setDrawer', 'toggleDrawer']),
    onResponsiveInverted () {
      if (window.innerWidth < 991) {
        this.responsive = true
      } else {
        this.responsive = false
      }
    },
    cerrarSesion(){
      sessionStorage.clear();
      this.$emit('cerrarSesion');
    }
  }
}
</script>

<style lang="scss">
  #app-drawer {
    .v-list__tile {
      border-radius: 4px;

      &--buy {
        margin-top: auto;
        margin-bottom: 17px;
      }
    }

    .v-image__image--contain {
      top: 9px;
      height: 60%;
    }

    .search-input {
      margin-bottom: 30px !important;
      padding-left: 15px;
      padding-right: 15px;
    }
  }
</style>
